import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import CloseIcon from '../../assets/CloseIcon'
import EditIcon from '../../assets/EditIcon'
import {
  PAGE_CONST,
  PERMISSION_TYPE,
  PROFILE_CONST,
  SETTINGS_NAVIGATION_ITEMS,
  SETTINGS_CONST,
} from '../../common/constant/page-constant'
import Header from '../Common/Header/Header'

import SideMenu from '../Common/SideMenu/SideMenu'

import {
  activeSettingsDetailNavigation,
  logoutAction,
} from '../../modules/actions/action'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import MobileHeader from '../Common/Header/MobileHeader'
import { SIDEBAR_CONST } from '../../common/constant/common-constant'

import './Settings.scss'
import { navigate } from '../../common/utils/redirectionUtils'
import PharmacyStore from '../PharmacyStore/PharmacyStore'
import ManageCustomer from '../ManageCustomer/ManageCustomer'
import ManageUser from '../ManageUser/ManageUser'
import PopupCard from '../Common/PopupCard/PopupCard'
import ManageSupplier from '../ManageSupplier/ManageSupplier'
import ManageProduct from '../ManageProduct/ManageProduct'
import PharmacyRequest from '../PharmacyRequest/PharmacyRequest'
import ConsumerOrders from '../ConsumerOrders/ConsumerOrders'

const Settings = (props) => {
  const isMobile = useCheckMobileScreen()

  const [viewDrawer, setViewDrawer] = useState(false)
  const [activeItem, setActiveItem] = useState(undefined)
  const [open, setOpen] = useState(false)
  const [permissions, setPermissions] = useState({})
  const [isConfirmLogout, setIsConfirmLogout] = useState(false)

  const headerOptions = {
    isBackVisible: false,
    title: 'Settings',
  }

  const handleDrawerToggle = () => {
    setViewDrawer(!viewDrawer)
    setOpen(!open)
  }

  useEffect(() => {
    // if (props.config?.activeSettingsDetailNavigation) {
    setActiveItem(props.config.activeSettingsDetailNavigation)
    // }
  }, [props.config?.activeSettingsDetailNavigation])

  const handleItemClick = (itemName) => {
    props.dispatchActiveSettingsDetailNavigation(itemName)
  }

  const handleClose = () => {
    navigate(PAGE_CONST.HOME)
  }

  const handleLogout = () => {
    props.logoutAction()
    // navigate(PAGE_CONST.LOGIN)
    navigate(PAGE_CONST.LOGIN)
  }

  useEffect(() => {
    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.reduce((acc, permission) => {
        acc.features = {
          ...acc.features,
          ...permission.features,
        }

        return acc
      }, {})

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  return (
    <div className="containerHome">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <SideMenu
        activeItem={SIDEBAR_CONST.SETTINGS}
        component={!activeItem && PAGE_CONST.SETTINGS}
      />
      <div className="pageBody">
        {!activeItem && (
          <div className="profileMenuWrapper">
            <ul className="profileMenuList">
              {SETTINGS_NAVIGATION_ITEMS.map((item) => {
                if (
                  permissions?.features?.[item.feature] !==
                  PERMISSION_TYPE.RESTRICTED
                ) {
                  return (
                    <li
                      className="menuItem"
                      onClick={() => handleItemClick(item.name)}
                    >
                      {item.profileDetailIcon} <span>{item.name}</span>
                    </li>
                  )
                }
              })}
            </ul>
            <div className="logOut" onClick={() => setIsConfirmLogout(true)}>
              Logout
            </div>
          </div>
        )}
        {activeItem === SETTINGS_CONST.PHARMACY_STORE && (
          <PharmacyStore onBackClick={() => handleItemClick(undefined)} />
        )}
        {activeItem === SETTINGS_CONST.CONSUMER && (
          <ManageCustomer onBackClick={() => handleItemClick(undefined)} />
        )}
        {activeItem === SETTINGS_CONST.CONSUMER_ORDERS && (
          <ConsumerOrders onBackClick={() => handleItemClick(undefined)} />
        )}
        {activeItem === SETTINGS_CONST.SUPPLIER && (
          <ManageSupplier onBackClick={() => handleItemClick(undefined)} />
        )}
        {activeItem === SETTINGS_CONST.MANAGE_USERS && (
          <ManageUser onBackClick={() => handleItemClick(undefined)} />
        )}
        {activeItem === SETTINGS_CONST.MANAGE_PRODUCT && (
          <ManageProduct onBackClick={() => handleItemClick(undefined)} />
        )}
        {activeItem === SETTINGS_CONST.COMMISSION_EARNINGS && (
          <div>COMMISSION_EARNINGS</div>
        )}
        {activeItem === SETTINGS_CONST.PLATFORM_CHARGES && (
          <div>PLATFORM_CHARGES</div>
        )}
        {activeItem === SETTINGS_CONST.PHARMACY_REQUESTS && (
          <PharmacyRequest onBackClick={() => handleItemClick(undefined)} />
        )}
      </div>
      {isConfirmLogout && (
        <PopupCard
          header="Are you sure you want to logout?"
          body="Lorem ipsum dolor sit t consectetur. Nulla bibendum ac ornare sodales.?"
        >
          <button
            className="btn btnPrimaryOutlined dFlex"
            onClick={() => setIsConfirmLogout(false)}
          >
            Cancel
          </button>
          <button className="btn btnPrimary dFlex" onClick={handleLogout}>
            Logout
          </button>
        </PopupCard>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    config: state.configReducer.config,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchActiveSettingsDetailNavigation: (payload) =>
      dispatch(activeSettingsDetailNavigation(payload)),
    logoutAction: () => dispatch(logoutAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
